var map = {
	"./footer.de-CH.json": 991,
	"./footer.de-DE.json": 992,
	"./footer.en-CA.json": 993,
	"./footer.en-GB.json": 994,
	"./footer.en-IN.json": 995,
	"./footer.en-ME.json": 996,
	"./footer.en-US.json": 997,
	"./footer.es-EM.json": 998,
	"./footer.es-ES.json": 999,
	"./footer.fr-BE.json": 1000,
	"./footer.fr-CA.json": 1001,
	"./footer.fr-CH.json": 1002,
	"./footer.nl-BE.json": 1003,
	"./footer.nl-NL.json": 1004,
	"./footer.pl-PL.json": 1005,
	"./footer.pt-BR.json": 1006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;